const STAGE = [
  {
    name: '精讲班计划',
    startTime: '预计2019年11月开启',
    body: {
      1: [
        {
          week: '第一周',
          detail: [
            {
              days: 1,
              content:
                '听第一章第一节 会计概念、职能和目标精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第一章第二节 会计基本假设、会计基础和会计信息质量要求精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第一章第三节 会计要素及其确认与计量精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第一章第四节 会计科目和借贷记账法精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content: '复习第一章1-4节',
            },
          ],
        },
        {
          week: '第二周',
          detail: [
            {
              days: 3,
              content:
                '听第一章第五节 会计凭证、会计账簿与账务处理程序精讲班的视频，做第五节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第一章第六节 财产清查精讲班的视频，做第六节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第一章第七节 财务报告精讲班的视频，做第七节的章节练习题',
            },
            { days: 1, content: '复习第一章' },
            {
              days: 1,
              content:
                '听第二章第一节 货币资金精讲班的视频，做第一节的章节练习题',
            },
          ],
        },
        {
          week: '第三周',
          detail: [
            {
              days: 2,
              content:
                '听第二章第二节 应收及预付款项精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第二章第三节 交易性金融资产精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 3,
              content: '听第二章第四节 存货精讲班的视频，做第四节的章节练习题',
            },
          ],
        },
        {
          week: '第四周',
          detail: [
            {
              days: 2,
              content: '复习第二章1-4节',
            },
            {
              days: 3,
              content:
                '听第二章第五节 固定资产精讲班的视频，做第五节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第六节 无形资产和长期待摊费用精讲班的视频，做第六节的章节练习题',
            },
            {
              days: 1,
              content: '复习第二章',
            },
          ],
        },
        {
          week: '第五周',
          detail: [
            {
              days: 1,
              content:
                '听第三章第一节 短期借款精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第三章第二节 应付及预收款项精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第三章第三节 应付职工薪酬精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 3,
              content:
                '听第三章第四节 应交税费精讲班的视频，做第四节的章节练习题',
            },
          ],
        },
        {
          week: '第六周',
          detail: [
            {
              days: 1,
              content:
                '听第四章第一节 实收资本或股本精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第四章第二节 资本公积精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第四章第三节 留存收益精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 4,
              content: '听第五章第一节 收入精讲班的视频，做第一节的章节练习题',
            },
          ],
        },
        {
          week: '第七周',
          detail: [
            {
              days: 1,
              content: '听第五章第二节 费用精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content: '听第五章第三节 利润精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第六章第一节 资产负债表精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content: '听第六章第二节 利润表精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第六章第三、四节 所有者权益变动表及附注精讲班的视频，做第三、四节的章节练习题',
            },
            { days: 2, content: '复习之前所学内容' },
          ],
        },
        {
          week: '第八周',
          detail: [
            {
              days: 1,
              content:
                '听第七章第一节 管理会计概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第七章第二节 产品成本核算的要求和一般程序精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 4,
              content:
                '听第七章第三节 产品成本的归集和分配精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第七章第四节 产品成本计算精讲班的视频，做第四节的章节练习题',
            },
          ],
        },
        {
          week: '第九周',
          detail: [
            {
              days: 2,
              content:
                '听第八章第一节 政府会计核算精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 3,
              content:
                '听第八章第二节 政府单位会计核算精讲班的视频，做第二节的章节练习题',
            },
            { days: 2, content: '复习本书内容' },
          ],
        },
      ],
      2: [
        {
          week: '第一周',
          detail: [
            {
              days: 2,
              content:
                '听第一章第一节 法律基础精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 3,
              content:
                '听第一章第二节 经济纠纷的解决途径精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第一章第三节 法律责任精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content: '复习本章所学内容',
            },
          ],
        },
        {
          week: '第二周',
          detail: [
            {
              days: 1,
              content:
                '听第二章第一节 会计法律制度概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第二章第二节 会计核算与监督精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第三节 会计机构和会计人员精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第四节 会计职业道德精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第五节 违反会计法律制度的法律责任精讲班的视频，做第五节的章节练习题',
            },
            { days: 1, content: '复习本章所学内容' },
          ],
        },
        {
          week: '第三周',
          detail: [
            {
              days: 1,
              content:
                '听第三章第一节 支付结算概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第三章第二节 银行结算账户精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 4,
              content: '听第三章第三节 票据精讲班的视频，做第三节的章节练习题',
            },
          ],
        },
        {
          week: '第四周',
          detail: [
            {
              days: 1,
              content:
                '听第三章第四、五节 银行卡和网上支付精讲班的视频，做第四、五节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第三章第六、七节 结算方式和其他支付工具、结算纪律与法律责任精讲班的视频，做第六、七节的章节练习题',
            },
            { days: 1, content: '复习本章所学内容' },
            {
              days: 1,
              content:
                '听第四章第一节 税收法律制度概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 3,
              content:
                '听第四章第二节 增值税法律制度精讲班的视频，做第二节的章节练习题',
            },
          ],
        },
        {
          week: '第五周',
          detail: [
            { days: 2, content: '复习第四章第2节' },
            {
              days: 4,
              content:
                '听第四章第三节 消费税法律制度精讲班的视频，做第三节的章节练习题',
            },
            { days: 1, content: '复习本章所学内容' },
          ],
        },
        {
          week: '第六周',
          detail: [
            {
              days: 5,
              content:
                '听第五章第一节 企业所得税法律制度精讲班的视频，做第一节的章节练习题',
            },
            { days: 2, content: '复习第五章第1节内容' },
          ],
        },
        {
          week: '第七周',
          detail: [
            {
              days: 3,
              content:
                '听第五章第二节 个人所得税法律制度精讲班的视频，做第二节的章节练习题',
            },
            { days: 1, content: '复习本章所学内容' },
            {
              days: 1,
              content:
                '听第六章第一、二节 房产税以及契税法律制度精讲班的视频，做第一、二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第六章第三节 土地增值税法律制度精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第六章第四、五节 城镇土地使用税以及车船税的法律制度精讲班的视频，做第四、五节的章节练习题',
            },
          ],
        },
        {
          week: '第八周',
          detail: [
            {
              days: 1,
              content:
                '听第六章第六节 印花税法律制度精讲班的视频，做第六节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第六章第七节 资源税法律制度精讲班的视频，做第七节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第六章第八节 其他相关税收法律制度精讲班的视频，做第八节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第七章第一、二节 税收征收管理法概述及税务管理精讲班的视频，做第一、二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第七章第三节 税款征收与税务检查精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第七章第四节 税务行政复议精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第七章第五节 税收法律责任精讲班的视频，做第五节的章节练习题',
            },
          ],
        },
        {
          week: '第九周',
          detail: [
            {
              days: 3,
              content:
                '听第八章第一节 劳动合同法律制度精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第八章第二节 社会保险法律制度精讲班的视频，做第二节的章节练习题',
            },
            { days: 2, content: '复习本书所学内容' },
          ],
        },
      ],
    },
  },
  {
    name: '习题班计划',
    startTime: '预计2020年2月开启',
    body: {
      1: [
        {
          week: '第一周',
          detail: [
            {
              days: 3,
              content:
                '做第一章习题班习题（下载习题班讲义练习），听习题班录播视频，做第一章考点专项练习（题库）',
            },
            {
              days: 4,
              content:
                '做第二章习题班习题（下载习题班讲义练习），听习题班录播视频，做第二章考点专项练习（题库）',
            },
          ],
        },
        {
          week: '第二周',
          detail: [
            {
              days: 3,
              content: '复习第二章的知识点',
            },
            {
              days: 3,
              content:
                '做第三章习题班习题（下载习题班讲义练习），听习题班录播视频，做第三章考点专项练习（题库）',
            },
            {
              days: 1,
              content:
                '做第四章习题班习题（下载习题班讲义练习），听习题班录播视频，做第四章考点专项练习（题库）',
            },
          ],
        },
        {
          week: '第三周',
          detail: [
            {
              days: 4,
              content:
                '做第五章习题班习题（下载习题班讲义练习），听习题班录播视频，做第五章考点专项练习（题库）',
            },
            {
              days: 2,
              content: '复习第五章的知识点',
            },
            {
              days: 1,
              content:
                '做第六章习题班习题（下载习题班讲义练习），听习题班录播视频，做第六章考点专项练习（题库）',
            },
          ],
        },
        {
          week: '第四周',
          detail: [
            {
              days: 3,
              content:
                '做第七章习题班习题（下载习题班讲义练习），听习题班录播视频，做第七章考点专项练习（题库）',
            },
            {
              days: 3,
              content:
                '做第八章习题班习题（下载习题班讲义练习），听习题班录播视频，做第八章考点专项练习（题库）',
            },
            {
              days: 1,
              content: '复习本书的内容',
            },
          ],
        },
      ],
      2: [
        {
          week: '第一周',
          detail: [
            {
              days: 3,
              content:
                '做第一章习题班习题（下载习题班讲义练习），听习题班录播视频，做第一章考点专项练习（题库）',
            },
            {
              days: 3,
              content:
                '做第二章习题班习题（下载习题班讲义练习），听习题班录播视频，做第二章考点专项练习（题库）',
            },
            {
              days: 1,
              content: '复习第一、二章的知识点',
            },
          ],
        },
        {
          week: '第二周',
          detail: [
            {
              days: 3,
              content: '做第三章习题班习题（下载习题班讲义练习），听习题班录播视频，做第三章考点专项练习（题库）',
            },
            {
              days: 4,
              content:
                '做第四章习题班习题（下载习题班讲义练习），听习题班录播视频，做第四章考点专项练习（题库）',
            },

          ],
        },
        {
          week: '第三周',
          detail: [
            {
              days: 2,
              content:
                '复习第三、四章的知识点',
            },
            {
              days: 4,
              content: '做第五章习题班习题（下载习题班讲义练习），听习题班录播视频，做第五章考点专项练习（题库）',
            },
            {
              days: 1,
              content:
                '复习第五章的知识点',
            },
          ],
        },
        {
          week: '第四周',
          detail: [
            {
              days: 2,
              content:
                '做第六章习题班习题（下载习题班讲义练习），听习题班录播视频，做第六章考点专项练习（题库）',
            },
            {
              days: 2,
              content:
                '做第七章习题班习题（下载习题班讲义练习），听习题班录播视频，做第七章考点专项练习（题库）',
            },
            {
              days: 2,
              content: '做第八章习题班习题（下载习题班讲义练习），听习题班录播视频，做第八章考点专项练习（题库）',
            },
            {
              days: 1,
              content: '复习本书的内容',
            },
          ],
        },
      ],
    },
  },
  {
    name: '冲刺班计划',
    startTime: '预计2020年4月开启',
    body: { 1: [], 2: [] },
  },
  {
    name: '急速提分班计划',
    startTime: '预计2020年4月份开启',
    body: { 1: [], 2: [] },
  },
  {
    name: '错题打印',
    startTime: '考前15天开启',
    body: { 1: [], 2: [] },
  },
  {
    name: '模考练兵直播',
    startTime: '考前开启',
    body: { 1: [], 2: [] },
  },
  {
    name: '考前押题直播',
    startTime: '考前开启',
    body: { 1: [], 2: [] },
  },
];

export default STAGE;
